import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface SheetHeaderState {
    title: string;
    showShare: boolean;
    showBack: boolean;
    headerBackground: string;
    headerBackgroundImage: string;
    headerHeight: string;
    headerTextColor: string;
    contentOverlap: boolean;
    contentPadding: string;
}

export const SHEET_HEADER_DEFAULTS: Omit<SheetHeaderState, 'title'> = {
    showShare: false,
    showBack: false,
    headerBackground: '#0158CC',
    headerBackgroundImage: '/images/circle-type1.svg',
    headerHeight: 'auto',
    headerTextColor: '#FFFFFF',
    contentOverlap: false,
    contentPadding: '20px 16px',
};

const initialState: SheetHeaderState = {
    title: '',
    ...SHEET_HEADER_DEFAULTS,
};

export const sheetHeaderSlice = createSlice({
    name: 'sheetHeader',
    initialState,
    reducers: {
        setSheetHeader: (
            state,
            action: PayloadAction<Partial<SheetHeaderState>>
        ) => {
            const payload = action.payload;
            if (payload.title !== undefined) state.title = payload.title;
            if (payload.showShare !== undefined)
                state.showShare = payload.showShare;
            if (payload.showBack !== undefined)
                state.showBack = payload.showBack;
            if (payload.headerBackground !== undefined)
                state.headerBackground = payload.headerBackground;
            if (payload.headerBackgroundImage !== undefined)
                state.headerBackgroundImage = payload.headerBackgroundImage;
            if (payload.headerHeight !== undefined)
                state.headerHeight = payload.headerHeight;
            if (payload.headerTextColor !== undefined)
                state.headerTextColor = payload.headerTextColor;
            if (payload.contentOverlap !== undefined)
                state.contentOverlap = payload.contentOverlap;
            if (payload.contentPadding !== undefined)
                state.contentPadding = payload.contentPadding;
        },
        resetSheetHeader: () => initialState,
    },
});

export const {setSheetHeader, resetSheetHeader} = sheetHeaderSlice.actions;
export default sheetHeaderSlice.reducer;
